import { render, staticRenderFns } from "./LocationwiseReports.vue?vue&type=template&id=6880a7bc&scoped=true"
import script from "./LocationwiseReports.vue?vue&type=script&lang=js"
export * from "./LocationwiseReports.vue?vue&type=script&lang=js"
import style0 from "./LocationwiseReports.vue?vue&type=style&index=0&id=6880a7bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6880a7bc",
  null
  
)

export default component.exports